var __WEBPACK_NAMESPACE_OBJECT__ = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "page-editor-ui": "static-1.31252",
      "apollo-dlb": "static-3.41",
      "backbone": "static-1.6",
      "codemirror-dlb": "static-1.52453",
      "collaboration-sidebar": "static-1.51521",
      "ContentComponents": "static-2.65503",
      "ContentData": "static-1.62622",
      "ContentEditorUI": "static-2.70901",
      "ContentUtils": "static-1.62545",
      "customer-agent-discovery-components-lib": "static-1.514",
      "data-fetching-client": "static-1.8202",
      "editor-components": "static-1.11621",
      "emoji-mart": "static-3.4",
      "FileManagerLib": "static-1.33339",
      "foundations-assets": "static-1.3520",
      "foundations-components": "static-1.5770",
      "head-dlb": "static-1.3679",
      "hs-test-utils": "static-1.6610",
      "hub-http": "static-1.4807",
      "hub-http-shared-msw-handlers": "static-1.6842",
      "hubspot-dlb": "static-2.1317",
      "HubStyleTokens": "static-2.10095",
      "I18n": "static-7.1368",
      "InpageEditorUI": "static-1.79343",
      "jasmine-immutable": "static-1.1563",
      "jasmine-runner": "static-1.5000",
      "layout-dnd-utils": "static-1.9516",
      "personalization-lib": "static-1.1078",
      "quartz": "static-1.5357",
      "react-dlb": "static-1.51",
      "react-dnd": "static-4.51",
      "react-dnd-html5-backend": "static-4.5",
      "react-redux": "static-7.16",
      "react-router-dom": "static-5.26",
      "react-utils": "static-2.4166",
      "redux-thunk": "static-2.43",
      "settings-ui-lib": "static-1.11166",
      "sinon": "static-1.9",
      "tinymce": "static-6.5",
      "ui-addon-draggable": "static-1.4362",
      "ui-components-test-utils": "static-1.4235",
      "ui-images": "static-2.804",
      "ui-memberships-settings-lib": "static-1.27559",
      "video-components-external": "static-1.5070",
      "webpack-env": "static-1.54",
      "ai-components-ui-library": "static-1.4966",
      "apollo-stack-hubspot": "static-3.43",
      "atom": "static-1.3853",
      "blueimp-md5": "static-1.8",
      "campaigns-lib": "static-1.21469",
      "classnames": "static-2.10",
      "content-assistance-lib": "static-1.6066",
      "content-management-data-lib": "static-1.3652",
      "copilot-plugins": "static-1.5490",
      "copilot-toolkit": "static-1.5516",
      "cropperjs": "static-1.10",
      "cssUtils": "static-1.455",
      "cta-picker": "static-1.30609",
      "customer-data-objects": "static-1.6189",
      "customer-data-objects-ui-components": "static-1.11488",
      "customer-data-properties": "static-1.44927",
      "customer-data-property-utils": "static-1.6525",
      "customer-data-reference-ui-components": "static-1.11587",
      "customer-data-ui-utilities": "static-1.8340",
      "data-token-picker": "static-1.13772",
      "data-token-views": "static-1.13753",
      "error-messaging-js": "static-1.3888",
      "feedback-loader": "static-1.26202",
      "file-manager-components": "static-1.17698",
      "FileManagerCore": "static-1.33198",
      "FormsCommonComponents": "static-1.80293",
      "foundations-theming": "static-1.2916",
      "fuzzy": "static-1.8",
      "growth-onboarding-confetti": "static-1.1709",
      "growth-payments-core": "static-1.20538",
      "history": "static-4.47",
      "hs-lodash": "static-4.45",
      "hs-promise-utils": "static-1.4118",
      "hub-http-contrib": "static-1.1785",
      "hubspot-url-utils": "static-1.2969",
      "HubStyle": "static-2.10404",
      "icons": "static-2.591",
      "immer": "static-1.33",
      "immutable": "static-2.19",
      "InboxConnectUtils": "static-4.9261",
      "integrations-lib": "static-1.9822",
      "interframe": "static-3.3404",
      "laboratory-lib": "static-3.5862",
      "layout-data-lib": "static-1.7841",
      "media-bridge-lib": "static-1.16394",
      "nav-meta": "static-1.25139",
      "object-builder-ui-client": "static-1.41107",
      "onboarding-scopes": "static-1.5146",
      "onboarding-tours": "static-1.13896",
      "onboarding-tours-client": "static-1.3116",
      "outpost": "static-1.2942",
      "PatternValidationJS": "static-1.437",
      "payment-link-components": "static-1.17813",
      "payments-post-enroll-local-storage-lib": "static-1.3684",
      "pictos": "static-7.158",
      "PortalIdParser": "static-2.272",
      "products-ui-components": "static-1.34713",
      "property-translator": "static-1.3979",
      "quick-fetch": "static-1.2772",
      "raven": "static-3.4440",
      "react": "static-7.151",
      "react-beautiful-dnd": "static-1.13",
      "react-colorpicker": "static-2.8826",
      "react-dom": "static-7.85",
      "react-flip-move": "static-1.46",
      "react-immutable-proptypes": "static-2.8",
      "react-input-autosize": "static-2.17",
      "react-rhumb": "static-1.15206",
      "react-select-plus": "static-1.65",
      "react-tinymce": "static-1.49893",
      "react-transition-group": "static-1.7",
      "react-virtualized": "static-2.73",
      "redux": "static-4.16",
      "redux-request-state": "static-1.9179",
      "reference-resolvers": "static-1.6756",
      "reference-resolvers-lite": "static-1.6551",
      "reselect": "static-2.16",
      "rich-text-lib": "static-1.17129",
      "sanitize": "static-1.2973",
      "sanitize-text": "static-1.6795",
      "seamless-immutable": "static-7.6",
      "self-service-api": "static-1.8795",
      "SharedI18nStrings": "static-1.162",
      "SharedLegalStrings": "static-1.1288",
      "simple-menus-core": "static-1.13310",
      "simple-menus-lib": "static-1.14828",
      "smart-content-lib": "static-1.37219",
      "styled-components": "static-2.40",
      "StyleGuideUI": "static-3.453",
      "superstore": "static-1.3385",
      "theme-previewer-lib": "static-1.47126",
      "tinymce-config": "static-2.49019",
      "tinymce-copilot": "static-1.11087",
      "tinymce-data": "static-1.35103",
      "tinymce-plugins": "static-1.52133",
      "tinymce-themes": "static-1.50988",
      "transmute": "static-2.29",
      "ui-addon-avatars": "static-2.8042",
      "ui-addon-emoji-picker": "static-1.8522",
      "ui-addon-form-validation": "static-1.9632",
      "ui-addon-i18n": "static-1.9520",
      "ui-addon-iframeable": "static-1.7501",
      "ui-addon-opt": "static-4.7260",
      "ui-addon-sales-email": "static-1.3805",
      "ui-addon-upgrades": "static-9.15752",
      "ui-business-units-lib": "static-1.7480",
      "ui-gdpr-components": "static-1.8861",
      "ui-product-approvals": "static-1.23341",
      "ui-shepherd-react": "static-3.8645",
      "ui-suspension-banners-lib": "static-1.5018",
      "UIComponents": "static-3.7044",
      "underscore": "static-1.8",
      "urlinator": "static-1.3147",
      "usage-tracker": "static-1.6070",
      "usage-tracker-core": "static-1.5920",
      "user-context": "static-1.3757",
      "video-embed": "static-1.29562",
      "web-interactives-components": "static-1.11207",
      "web-interactives-data": "static-1.11208",
      "wootric-nps": "static-1.5565",
      "xray-recommendation-lib": "static-1.5672",
      "codemirror": "static-5.69",
      "react-codemirror": "static-1.9197",
      "enviro": "static-4.293",
      "hs-promise-rejection-tracking": "static-1.3967",
      "raven-hubspot": "static-1.4747",
      "hoist-non-react-statics": "static-3.9",
      "metrics-js": "static-1.8343",
      "bend-plugin-trellis-migration": "static-1.2280",
      "moment": "static-3.26",
      "jquery": "static-3.6",
      "chatspot-client-types": "static-1.8340",
      "chatspot-core": "static-1.14759",
      "chatspot-widget-iframe": "static-1.14755",
      "framework-data-schema-resolvers": "static-1.5462",
      "frontend-preferences-client": "static-1.6482",
      "graphql": "static-1.58",
      "quartz-core": "static-1.4576",
      "cms-field-types": "static-1.3384",
      "content-embed-lib": "static-1.5957",
      "ExportDialog": "static-6.9001",
      "forms-utils-lib": "static-1.9926",
      "integrations-error-boundary-lib": "static-1.7236",
      "payments-embed-points-lib": "static-1.8939",
      "react-dnd-compat": "static-1.3242",
      "usage-tracker-container": "static-1.6060",
      "video-data-lib": "static-1.28719",
      "videoconference-integration-components": "static-1.4712",
      "editor-iframe-lib": "static-1.6904",
      "FireAlarmUi": "static-1.3476",
      "hubspot-apollo-client": "static-1.3428",
      "layout-dnd-components": "static-1.10541",
      "marketing-email-service-types": "static-1.1408",
      "rpc-client-utils": "static-1.3334",
      "smart-content-core": "static-1.36565",
      "social-composer-lib": "static-1.52710",
      "structured-content-lib": "static-1.19506",
      "timezone-utils": "static-2.3868",
      "ui-active-theme-content-creator-lib": "static-1.31052",
      "ui-addon-video-player": "static-1.7377",
      "ui-asset-management-lib": "static-1.8799",
      "ui-tool-access": "static-1.8644",
      "content-icons-ui": "static-1.1862",
      "react-aria": "static-1.38",
      "FileManagerImages": "static-1.30849",
      "hs-story-utils": "static-1.7997",
      "bend-plugin-foundations-components": "static-1.2038",
      "floating-ui": "static-1.28",
      "foundations-theming-specialty": "static-1.633",
      "framer-motion": "static-1.40",
      "tanstack-table": "static-1.23",
      "ui-fonts": "static-1.331",
      "HeadJS": "static-2.562",
      "hs-test-utils-bend-plugin": "static-1.1721",
      "msw": "static-1.39",
      "testing-library": "static-1.120",
      "ts-schema": "static-1.2978",
      "i18n-data": "static-1.196",
      "moment-timezone": "static-5.51",
      "NamespacedHubStyle": "static-2.8070",
      "react-dnd-ipeui-backend": "static-1.665",
      "ui-coaching-tips": "static-1.21821",
      "jasmine": "static-4.2955",
      "quartz-core-utils": "static-1.2224",
      "flux-actions": "static-1.266",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.9072",
      "rxjs": "static-5.10",
      "foundations-components-test-utils": "static-1.3255",
      "apollo-link-hub-http": "static-2.3392",
      "content-media-compositions": "static-2.9303",
      "idb-keyval": "static-1.20",
      "immerable": "static-1.2770",
      "magpie-lib": "static-1.4282",
      "magpie-types": "static-1.3742",
      "video-components": "static-1.7073",
      "autolinker": "static-3.11",
      "foundations-theming-base": "static-1.1901",
      "sassPrefix": "static-1.129",
      "attribution-lib": "static-1.36901",
      "campaigns-build-lib": "static-1.6856",
      "crm-pipelines-api-client-types": "static-1.2954",
      "marketing-platform-lib": "static-1.5260",
      "reporting-ui-components": "static-2.58182",
      "ai-rendering-library": "static-1.4370",
      "ui-brand-identity-lib": "static-1.7713",
      "avatar-components": "static-1.1007",
      "commerce-products-lib": "static-1.4191",
      "conditional-properties-service-client": "static-1.2770",
      "crm-links": "static-1.4717",
      "crm-message-bus": "static-1.35820",
      "enrichment-properties-lib": "static-1.8913",
      "external-options-client-types": "static-1.2927",
      "google-libphonenumber": "static-1.11",
      "inbound-db-properties-service-client": "static-1.2793",
      "inbounddb-objects-service-types": "static-1.3062",
      "pipeline-validation-client-types": "static-1.2723",
      "react-immutable-render-mixin": "static-1.9",
      "audio-components": "static-1.4210",
      "salesImages": "static-1.498",
      "forms-ai-lib": "static-1.2013",
      "bend-plugin-foundations-theming": "static-1.1399",
      "commerce-analytics-service-client": "static-1.2402",
      "integrations-tracking-lib": "static-1.4070",
      "native-integrations-shared-strings": "static-1.6424",
      "getting-started-shared-tasks": "static-1.11424",
      "growth-data-modal": "static-1.3796",
      "navigation-components": "static-1.13502",
      "ui-shepherd-tracker": "static-1.6026",
      "ui-universal-auth": "static-1.7402",
      "commerce-tours-lib": "static-1.3110",
      "growth-onboarding-reliability": "static-1.3744",
      "sales-checkout-service-client": "static-1.2414",
      "commerce-shared-components-lib": "static-1.14213",
      "commerce-subscription-lib": "static-1.30494",
      "crm_components": "static-3.86162",
      "crm_data": "static-4.86162",
      "customer-data-filters-ui": "static-1.33043",
      "customer-data-tracking": "static-1.5415",
      "dispatcher": "static-1.111",
      "framework-data-table": "static-2.8191",
      "property-description-translator": "static-1.2443",
      "csstype": "static-1.38",
      "fast-json-stable-stringify": "static-1.4",
      "redux-mock-store": "static-1.8",
      "redux-undo": "static-1.10",
      "hubspotter-http": "static-1.3400",
      "navigation-messaging": "static-1.2829",
      "feature-store-service-types": "static-1.3284",
      "growth-monetization-service-types": "static-1.3291",
      "upgrade-management-service-types": "static-1.3275",
      "getting-started-shared-tasks-store": "static-1.10542",
      "diff-match-patch": "static-1.7",
      "browser-eslint": "static-2.57",
      "framework-builder-read-service-client": "static-1.2901",
      "framework-data-schema-quick-fetch": "static-1.5367",
      "inbound-db-meta-service-client": "static-1.2616",
      "persist-promise": "static-1.2351",
      "hub-http-janus": "static-1.633",
      "general-store": "static-6.20",
      "hubspotter-http-shared-msw-handlers": "static-1.6840",
      "mobile-manifest-mixins": "static-1.333",
      "platform-navigation-bootstrap": "static-1.10997",
      "payments-enrollment-embed-lib": "static-1.17038",
      "growth-onboarding-feedback-components": "static-1.5063",
      "simple-logging-lib": "static-1.1648",
      "social-insights-client-types": "static-1.17246",
      "FormUrlGenerator": "static-2.3317",
      "highcharts": "static-8.80",
      "report-customization-components": "static-1.8157",
      "reporting-action-components": "static-1.35471",
      "reporting-data": "static-1.60901",
      "reporting-enablement": "static-1.16252",
      "reporting-snowflake": "static-1.49525",
      "reporting-visualizations": "static-1.52981",
      "customer-data-filters": "static-1.46857",
      "reporting-plugins": "static-1.6339",
      "reporting-reports": "static-1.60588",
      "highlight.js": "static-1.45",
      "markdown-it": "static-1.6",
      "react-table": "static-1.15",
      "ui-addon-teams": "static-1.19486",
      "products-iframe-lib": "static-1.2203",
      "products-ui-components-shared-msw-handlers": "static-1.7227",
      "location-customization-utils-lib": "static-1.3396",
      "breeze-intelligence-kit": "static-1.3815",
      "crm-source-interpretation-lib": "static-1.3871",
      "fsm": "static-1.2298",
      "policy-lib": "static-1.5405",
      "final-form": "static-1.39",
      "redux-toolkit": "static-1.7",
      "universal-page-editor-lib": "static-1.1541",
      "commerce-billing-lib": "static-1.14142",
      "commerce-contract-lib": "static-1.5299",
      "commerce-tools-ui-lib": "static-1.5928",
      "conversations-skeleton-state": "static-1.5999",
      "crm_universal": "static-1.20341",
      "customer-data-content": "static-1.24139",
      "crm_schema": "static-3.86198",
      "customer-data-email": "static-1.15493",
      "customer-data-filters-ui-msw-helpers": "static-1.15475",
      "lodash": "static-4.7",
      "customer-data-associations": "static-1.5809",
      "platform-infra-nav-components": "static-1.6527",
      "marketplace-ui-apps-core": "static-1.12002",
      "stripe-embedded-components": "static-1.4928",
      "dashboard-lib": "static-1.74990",
      "share-with-third-party-component-lib": "static-1.7243",
      "reporting-client-types": "static-1.1767",
      "data-quality-ui-library": "static-1.7330",
      "html-to-image": "static-1.29",
      "reporting-datasets-permissions-lib": "static-1.6635",
      "deep-diff": "static-1.5",
      "campaign-roi-lib": "static-1.2056",
      "multi-currency-client-types": "static-1.2662",
      "sales-views-client-types": "static-1.2959",
      "crm-record-cards-service-types": "static-1.2629",
      "trellis-story-utils": "static-1.3157",
      "usage-tracker-session-replay": "static-1.2954",
      "utility-belt": "static-1.1182",
      "crm-cards-sdk": "static-1.37335",
      "customer-data-rte": "static-1.28411",
      "cv-backend-services": "static-1.1110",
      "growth-onboarding-empty-states": "static-1.3768",
      "hubspot-prosemirror": "static-1.13017",
      "prosemirror": "static-1.13",
      "qrcode-generator": "static-1.43",
      "SalesContentIndexUI": "static-3.6806",
      "sequences-lib": "static-1.5625",
      "developer-experience-shared-components": "static-1.8677",
      "immutable-less": "static-1.3164",
      "marketplace-ui-client-types": "static-1.10872",
      "marketplace-ui-common": "static-1.13466",
      "ui-addon-integrations-directory-panel": "static-2.6590",
      "ui-extensibility-client-types": "static-1.2816",
      "stripe-connect-js": "static-1.37",
      "redux-actions": "static-3.7",
      "ui-addon-react-router-dom": "static-1.8219",
      "amplitude-session-replay-browser": "static-1.6",
      "crm-actions": "static-1.4661",
      "crm-fe-perf": "static-1.21583",
      "draft-content-plugins": "static-1.23730",
      "draft-convert": "static-2.31",
      "draft-extend": "static-2.46",
      "draft-js": "static-5.37",
      "draft-plugins": "static-2.18950",
      "knowledge-content-types": "static-1.7617",
      "sequences-client-types-lib": "static-1.5481",
      "apps-service-types": "static-1.2816",
      "oauth-service-types": "static-1.2915",
      "react-window": "static-1.13"
    },
    "depPathPrefixes": {
      "page-editor-ui": "/page-editor-ui/static-1.31252",
      "apollo-dlb": "/apollo-dlb/static-3.41",
      "backbone": "/backbone/static-1.6",
      "codemirror-dlb": "/codemirror-dlb/static-1.52453",
      "collaboration-sidebar": "/collaboration-sidebar/static-1.51521",
      "ContentComponents": "/ContentComponents/static-2.65503",
      "ContentData": "/ContentData/static-1.62622",
      "ContentEditorUI": "/ContentEditorUI/static-2.70901",
      "ContentUtils": "/ContentUtils/static-1.62545",
      "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.514",
      "data-fetching-client": "/data-fetching-client/static-1.8202",
      "editor-components": "/editor-components/static-1.11621",
      "emoji-mart": "/emoji-mart/static-3.4",
      "FileManagerLib": "/FileManagerLib/static-1.33339",
      "foundations-assets": "/foundations-assets/static-1.3520",
      "foundations-components": "/foundations-components/static-1.5770",
      "head-dlb": "/head-dlb/static-1.3679",
      "hs-test-utils": "/hs-test-utils/static-1.6610",
      "hub-http": "/hub-http/static-1.4807",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.6842",
      "hubspot-dlb": "/hubspot-dlb/static-2.1317",
      "HubStyleTokens": "/HubStyleTokens/static-2.10095",
      "I18n": "/I18n/static-7.1368",
      "InpageEditorUI": "/InpageEditorUI/static-1.79343",
      "jasmine-immutable": "/jasmine-immutable/static-1.1563",
      "jasmine-runner": "/jasmine-runner/static-1.5000",
      "layout-dnd-utils": "/layout-dnd-utils/static-1.9516",
      "personalization-lib": "/personalization-lib/static-1.1078",
      "quartz": "/quartz/static-1.5357",
      "react-dlb": "/react-dlb/static-1.51",
      "react-dnd": "/react-dnd/static-4.51",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-4.5",
      "react-redux": "/react-redux/static-7.16",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-utils": "/react-utils/static-2.4166",
      "redux-thunk": "/redux-thunk/static-2.43",
      "settings-ui-lib": "/settings-ui-lib/static-1.11166",
      "sinon": "/sinon/static-1.9",
      "tinymce": "/tinymce/static-6.5",
      "ui-addon-draggable": "/ui-addon-draggable/static-1.4362",
      "ui-components-test-utils": "/ui-components-test-utils/static-1.4235",
      "ui-images": "/ui-images/static-2.804",
      "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.27559",
      "video-components-external": "/video-components-external/static-1.5070",
      "webpack-env": "/webpack-env/static-1.54",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.4966",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.43",
      "atom": "/atom/static-1.3853",
      "blueimp-md5": "/blueimp-md5/static-1.8",
      "campaigns-lib": "/campaigns-lib/static-1.21469",
      "classnames": "/classnames/static-2.10",
      "content-assistance-lib": "/content-assistance-lib/static-1.6066",
      "content-management-data-lib": "/content-management-data-lib/static-1.3652",
      "copilot-plugins": "/copilot-plugins/static-1.5490",
      "copilot-toolkit": "/copilot-toolkit/static-1.5516",
      "cropperjs": "/cropperjs/static-1.10",
      "cssUtils": "/cssUtils/static-1.455",
      "cta-picker": "/cta-picker/static-1.30609",
      "customer-data-objects": "/customer-data-objects/static-1.6189",
      "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.11488",
      "customer-data-properties": "/customer-data-properties/static-1.44927",
      "customer-data-property-utils": "/customer-data-property-utils/static-1.6525",
      "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.11587",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.8340",
      "data-token-picker": "/data-token-picker/static-1.13772",
      "data-token-views": "/data-token-views/static-1.13753",
      "error-messaging-js": "/error-messaging-js/static-1.3888",
      "feedback-loader": "/feedback-loader/static-1.26202",
      "file-manager-components": "/file-manager-components/static-1.17698",
      "FileManagerCore": "/FileManagerCore/static-1.33198",
      "FormsCommonComponents": "/FormsCommonComponents/static-1.80293",
      "foundations-theming": "/foundations-theming/static-1.2916",
      "fuzzy": "/fuzzy/static-1.8",
      "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.1709",
      "growth-payments-core": "/growth-payments-core/static-1.20538",
      "history": "/history/static-4.47",
      "hs-lodash": "/hs-lodash/static-4.45",
      "hs-promise-utils": "/hs-promise-utils/static-1.4118",
      "hub-http-contrib": "/hub-http-contrib/static-1.1785",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.2969",
      "HubStyle": "/HubStyle/static-2.10404",
      "icons": "/icons/static-2.591",
      "immer": "/immer/static-1.33",
      "immutable": "/immutable/static-2.19",
      "InboxConnectUtils": "/InboxConnectUtils/static-4.9261",
      "integrations-lib": "/integrations-lib/static-1.9822",
      "interframe": "/interframe/static-3.3404",
      "laboratory-lib": "/laboratory-lib/static-3.5862",
      "layout-data-lib": "/layout-data-lib/static-1.7841",
      "media-bridge-lib": "/media-bridge-lib/static-1.16394",
      "nav-meta": "/nav-meta/static-1.25139",
      "object-builder-ui-client": "/object-builder-ui-client/static-1.41107",
      "onboarding-scopes": "/onboarding-scopes/static-1.5146",
      "onboarding-tours": "/onboarding-tours/static-1.13896",
      "onboarding-tours-client": "/onboarding-tours-client/static-1.3116",
      "outpost": "/outpost/static-1.2942",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "payment-link-components": "/payment-link-components/static-1.17813",
      "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.3684",
      "pictos": "/pictos/static-7.158",
      "PortalIdParser": "/PortalIdParser/static-2.272",
      "products-ui-components": "/products-ui-components/static-1.34713",
      "property-translator": "/property-translator/static-1.3979",
      "quick-fetch": "/quick-fetch/static-1.2772",
      "raven": "/raven/static-3.4440",
      "react": "/react/static-7.151",
      "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
      "react-colorpicker": "/react-colorpicker/static-2.8826",
      "react-dom": "/react-dom/static-7.85",
      "react-flip-move": "/react-flip-move/static-1.46",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-rhumb": "/react-rhumb/static-1.15206",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-tinymce": "/react-tinymce/static-1.49893",
      "react-transition-group": "/react-transition-group/static-1.7",
      "react-virtualized": "/react-virtualized/static-2.73",
      "redux": "/redux/static-4.16",
      "redux-request-state": "/redux-request-state/static-1.9179",
      "reference-resolvers": "/reference-resolvers/static-1.6756",
      "reference-resolvers-lite": "/reference-resolvers-lite/static-1.6551",
      "reselect": "/reselect/static-2.16",
      "rich-text-lib": "/rich-text-lib/static-1.17129",
      "sanitize": "/sanitize/static-1.2973",
      "sanitize-text": "/sanitize-text/static-1.6795",
      "seamless-immutable": "/seamless-immutable/static-7.6",
      "self-service-api": "/self-service-api/static-1.8795",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.162",
      "SharedLegalStrings": "/SharedLegalStrings/static-1.1288",
      "simple-menus-core": "/simple-menus-core/static-1.13310",
      "simple-menus-lib": "/simple-menus-lib/static-1.14828",
      "smart-content-lib": "/smart-content-lib/static-1.37219",
      "styled-components": "/styled-components/static-2.40",
      "StyleGuideUI": "/StyleGuideUI/static-3.453",
      "superstore": "/superstore/static-1.3385",
      "theme-previewer-lib": "/theme-previewer-lib/static-1.47126",
      "tinymce-config": "/tinymce-config/static-2.49019",
      "tinymce-copilot": "/tinymce-copilot/static-1.11087",
      "tinymce-data": "/tinymce-data/static-1.35103",
      "tinymce-plugins": "/tinymce-plugins/static-1.52133",
      "tinymce-themes": "/tinymce-themes/static-1.50988",
      "transmute": "/transmute/static-2.29",
      "ui-addon-avatars": "/ui-addon-avatars/static-2.8042",
      "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.8522",
      "ui-addon-form-validation": "/ui-addon-form-validation/static-1.9632",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.9520",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.7501",
      "ui-addon-opt": "/ui-addon-opt/static-4.7260",
      "ui-addon-sales-email": "/ui-addon-sales-email/static-1.3805",
      "ui-addon-upgrades": "/ui-addon-upgrades/static-9.15752",
      "ui-business-units-lib": "/ui-business-units-lib/static-1.7480",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.8861",
      "ui-product-approvals": "/ui-product-approvals/static-1.23341",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.8645",
      "ui-suspension-banners-lib": "/ui-suspension-banners-lib/static-1.5018",
      "UIComponents": "/UIComponents/static-3.7044",
      "underscore": "/underscore/static-1.8",
      "urlinator": "/urlinator/static-1.3147",
      "usage-tracker": "/usage-tracker/static-1.6070",
      "usage-tracker-core": "/usage-tracker-core/static-1.5920",
      "user-context": "/user-context/static-1.3757",
      "video-embed": "/video-embed/static-1.29562",
      "web-interactives-components": "/web-interactives-components/static-1.11207",
      "web-interactives-data": "/web-interactives-data/static-1.11208",
      "wootric-nps": "/wootric-nps/static-1.5565",
      "xray-recommendation-lib": "/xray-recommendation-lib/static-1.5672",
      "codemirror": "/codemirror/static-5.69",
      "react-codemirror": "/react-codemirror/static-1.9197",
      "enviro": "/enviro/static-4.293",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.3967",
      "raven-hubspot": "/raven-hubspot/static-1.4747",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "metrics-js": "/metrics-js/static-1.8343",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.2280",
      "moment": "/moment/static-3.26",
      "jquery": "/jquery/static-3.6",
      "chatspot-client-types": "/chatspot-client-types/static-1.8340",
      "chatspot-core": "/chatspot-core/static-1.14759",
      "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.14755",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.5462",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.6482",
      "graphql": "/graphql/static-1.58",
      "quartz-core": "/quartz-core/static-1.4576",
      "cms-field-types": "/cms-field-types/static-1.3384",
      "content-embed-lib": "/content-embed-lib/static-1.5957",
      "ExportDialog": "/ExportDialog/static-6.9001",
      "forms-utils-lib": "/forms-utils-lib/static-1.9926",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.7236",
      "payments-embed-points-lib": "/payments-embed-points-lib/static-1.8939",
      "react-dnd-compat": "/react-dnd-compat/static-1.3242",
      "usage-tracker-container": "/usage-tracker-container/static-1.6060",
      "video-data-lib": "/video-data-lib/static-1.28719",
      "videoconference-integration-components": "/videoconference-integration-components/static-1.4712",
      "editor-iframe-lib": "/editor-iframe-lib/static-1.6904",
      "FireAlarmUi": "/FireAlarmUi/static-1.3476",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.3428",
      "layout-dnd-components": "/layout-dnd-components/static-1.10541",
      "marketing-email-service-types": "/marketing-email-service-types/static-1.1408",
      "rpc-client-utils": "/rpc-client-utils/static-1.3334",
      "smart-content-core": "/smart-content-core/static-1.36565",
      "social-composer-lib": "/social-composer-lib/static-1.52710",
      "structured-content-lib": "/structured-content-lib/static-1.19506",
      "timezone-utils": "/timezone-utils/static-2.3868",
      "ui-active-theme-content-creator-lib": "/ui-active-theme-content-creator-lib/static-1.31052",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.7377",
      "ui-asset-management-lib": "/ui-asset-management-lib/static-1.8799",
      "ui-tool-access": "/ui-tool-access/static-1.8644",
      "content-icons-ui": "/content-icons-ui/static-1.1862",
      "react-aria": "/react-aria/static-1.38",
      "FileManagerImages": "/FileManagerImages/static-1.30849",
      "hs-story-utils": "/hs-story-utils/static-1.7997",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.2038",
      "floating-ui": "/floating-ui/static-1.28",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.633",
      "framer-motion": "/framer-motion/static-1.40",
      "tanstack-table": "/tanstack-table/static-1.23",
      "ui-fonts": "/ui-fonts/static-1.331",
      "HeadJS": "/HeadJS/static-2.562",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.1721",
      "msw": "/msw/static-1.39",
      "testing-library": "/testing-library/static-1.120",
      "ts-schema": "/ts-schema/static-1.2978",
      "i18n-data": "/i18n-data/static-1.196",
      "moment-timezone": "/moment-timezone/static-5.51",
      "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8070",
      "react-dnd-ipeui-backend": "/react-dnd-ipeui-backend/static-1.665",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.21821",
      "jasmine": "/jasmine/static-4.2955",
      "quartz-core-utils": "/quartz-core-utils/static-1.2224",
      "flux-actions": "/flux-actions/static-1.266",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.9072",
      "rxjs": "/rxjs/static-5.10",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.3255",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.3392",
      "content-media-compositions": "/content-media-compositions/static-2.9303",
      "idb-keyval": "/idb-keyval/static-1.20",
      "immerable": "/immerable/static-1.2770",
      "magpie-lib": "/magpie-lib/static-1.4282",
      "magpie-types": "/magpie-types/static-1.3742",
      "video-components": "/video-components/static-1.7073",
      "autolinker": "/autolinker/static-3.11",
      "foundations-theming-base": "/foundations-theming-base/static-1.1901",
      "sassPrefix": "/sassPrefix/static-1.129",
      "attribution-lib": "/attribution-lib/static-1.36901",
      "campaigns-build-lib": "/campaigns-build-lib/static-1.6856",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.2954",
      "marketing-platform-lib": "/marketing-platform-lib/static-1.5260",
      "reporting-ui-components": "/reporting-ui-components/static-2.58182",
      "ai-rendering-library": "/ai-rendering-library/static-1.4370",
      "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.7713",
      "avatar-components": "/avatar-components/static-1.1007",
      "commerce-products-lib": "/commerce-products-lib/static-1.4191",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.2770",
      "crm-links": "/crm-links/static-1.4717",
      "crm-message-bus": "/crm-message-bus/static-1.35820",
      "enrichment-properties-lib": "/enrichment-properties-lib/static-1.8913",
      "external-options-client-types": "/external-options-client-types/static-1.2927",
      "google-libphonenumber": "/google-libphonenumber/static-1.11",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.2793",
      "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3062",
      "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.2723",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "audio-components": "/audio-components/static-1.4210",
      "salesImages": "/salesImages/static-1.498",
      "forms-ai-lib": "/forms-ai-lib/static-1.2013",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.1399",
      "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.2402",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.4070",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.6424",
      "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.11424",
      "growth-data-modal": "/growth-data-modal/static-1.3796",
      "navigation-components": "/navigation-components/static-1.13502",
      "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.6026",
      "ui-universal-auth": "/ui-universal-auth/static-1.7402",
      "commerce-tours-lib": "/commerce-tours-lib/static-1.3110",
      "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.3744",
      "sales-checkout-service-client": "/sales-checkout-service-client/static-1.2414",
      "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.14213",
      "commerce-subscription-lib": "/commerce-subscription-lib/static-1.30494",
      "crm_components": "/crm_components/static-3.86162",
      "crm_data": "/crm_data/static-4.86162",
      "customer-data-filters-ui": "/customer-data-filters-ui/static-1.33043",
      "customer-data-tracking": "/customer-data-tracking/static-1.5415",
      "dispatcher": "/dispatcher/static-1.111",
      "framework-data-table": "/framework-data-table/static-2.8191",
      "property-description-translator": "/property-description-translator/static-1.2443",
      "csstype": "/csstype/static-1.38",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "redux-mock-store": "/redux-mock-store/static-1.8",
      "redux-undo": "/redux-undo/static-1.10",
      "hubspotter-http": "/hubspotter-http/static-1.3400",
      "navigation-messaging": "/navigation-messaging/static-1.2829",
      "feature-store-service-types": "/feature-store-service-types/static-1.3284",
      "growth-monetization-service-types": "/growth-monetization-service-types/static-1.3291",
      "upgrade-management-service-types": "/upgrade-management-service-types/static-1.3275",
      "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.10542",
      "diff-match-patch": "/diff-match-patch/static-1.7",
      "browser-eslint": "/browser-eslint/static-2.57",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.2901",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.5367",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.2616",
      "persist-promise": "/persist-promise/static-1.2351",
      "hub-http-janus": "/hub-http-janus/static-1.633",
      "general-store": "/general-store/static-6.20",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.6840",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.333",
      "platform-navigation-bootstrap": "/platform-navigation-bootstrap/static-1.10997",
      "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.17038",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.5063",
      "simple-logging-lib": "/simple-logging-lib/static-1.1648",
      "social-insights-client-types": "/social-insights-client-types/static-1.17246",
      "FormUrlGenerator": "/FormUrlGenerator/static-2.3317",
      "highcharts": "/highcharts/static-8.80",
      "report-customization-components": "/report-customization-components/static-1.8157",
      "reporting-action-components": "/reporting-action-components/static-1.35471",
      "reporting-data": "/reporting-data/static-1.60901",
      "reporting-enablement": "/reporting-enablement/static-1.16252",
      "reporting-snowflake": "/reporting-snowflake/static-1.49525",
      "reporting-visualizations": "/reporting-visualizations/static-1.52981",
      "customer-data-filters": "/customer-data-filters/static-1.46857",
      "reporting-plugins": "/reporting-plugins/static-1.6339",
      "reporting-reports": "/reporting-reports/static-1.60588",
      "highlight.js": "/highlight.js/static-1.45",
      "markdown-it": "/markdown-it/static-1.6",
      "react-table": "/react-table/static-1.15",
      "ui-addon-teams": "/ui-addon-teams/static-1.19486",
      "products-iframe-lib": "/products-iframe-lib/static-1.2203",
      "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.7227",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.3396",
      "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.3815",
      "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.3871",
      "fsm": "/fsm/static-1.2298",
      "policy-lib": "/policy-lib/static-1.5405",
      "final-form": "/final-form/static-1.39",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.1541",
      "commerce-billing-lib": "/commerce-billing-lib/static-1.14142",
      "commerce-contract-lib": "/commerce-contract-lib/static-1.5299",
      "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.5928",
      "conversations-skeleton-state": "/conversations-skeleton-state/static-1.5999",
      "crm_universal": "/crm_universal/static-1.20341",
      "customer-data-content": "/customer-data-content/static-1.24139",
      "crm_schema": "/crm_schema/static-3.86198",
      "customer-data-email": "/customer-data-email/static-1.15493",
      "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.15475",
      "lodash": "/lodash/static-4.7",
      "customer-data-associations": "/customer-data-associations/static-1.5809",
      "platform-infra-nav-components": "/platform-infra-nav-components/static-1.6527",
      "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.12002",
      "stripe-embedded-components": "/stripe-embedded-components/static-1.4928",
      "dashboard-lib": "/dashboard-lib/static-1.74990",
      "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.7243",
      "reporting-client-types": "/reporting-client-types/static-1.1767",
      "data-quality-ui-library": "/data-quality-ui-library/static-1.7330",
      "html-to-image": "/html-to-image/static-1.29",
      "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.6635",
      "deep-diff": "/deep-diff/static-1.5",
      "campaign-roi-lib": "/campaign-roi-lib/static-1.2056",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.2662",
      "sales-views-client-types": "/sales-views-client-types/static-1.2959",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.2629",
      "trellis-story-utils": "/trellis-story-utils/static-1.3157",
      "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.2954",
      "utility-belt": "/utility-belt/static-1.1182",
      "crm-cards-sdk": "/crm-cards-sdk/static-1.37335",
      "customer-data-rte": "/customer-data-rte/static-1.28411",
      "cv-backend-services": "/cv-backend-services/static-1.1110",
      "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.3768",
      "hubspot-prosemirror": "/hubspot-prosemirror/static-1.13017",
      "prosemirror": "/prosemirror/static-1.13",
      "qrcode-generator": "/qrcode-generator/static-1.43",
      "SalesContentIndexUI": "/SalesContentIndexUI/static-3.6806",
      "sequences-lib": "/sequences-lib/static-1.5625",
      "developer-experience-shared-components": "/developer-experience-shared-components/static-1.8677",
      "immutable-less": "/immutable-less/static-1.3164",
      "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.10872",
      "marketplace-ui-common": "/marketplace-ui-common/static-1.13466",
      "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.6590",
      "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.2816",
      "stripe-connect-js": "/stripe-connect-js/static-1.37",
      "redux-actions": "/redux-actions/static-3.7",
      "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.8219",
      "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.6",
      "crm-actions": "/crm-actions/static-1.4661",
      "crm-fe-perf": "/crm-fe-perf/static-1.21583",
      "draft-content-plugins": "/draft-content-plugins/static-1.23730",
      "draft-convert": "/draft-convert/static-2.31",
      "draft-extend": "/draft-extend/static-2.46",
      "draft-js": "/draft-js/static-5.37",
      "draft-plugins": "/draft-plugins/static-2.18950",
      "knowledge-content-types": "/knowledge-content-types/static-1.7617",
      "sequences-client-types-lib": "/sequences-client-types-lib/static-1.5481",
      "apps-service-types": "/apps-service-types/static-1.2816",
      "oauth-service-types": "/oauth-service-types/static-1.2915",
      "react-window": "/react-window/static-1.13"
    },
    "project": "page-editor-ui",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};